/**
 * Infiltration Run — the 16 event pool.
 * Each run randomly draws 5-6 of these (no repeats). Numbers are tuned for a
 * base agent stat of ~10: safe='none' (100%), risky ~65-70%, aggressive ~20-35%.
 * Conspiracy-parody theme. All display text goes through i18n keys.
 */

import type { InfilEvent } from './infiltration.js';

export const INFIL_EVENTS: InfilEvent[] = [
  {
    id: 'patrol', titleKey: 'infil_ev_patrol_title', categoryKey: 'infil_ev_patrol_cat',
    descKey: 'infil_ev_patrol_desc', imagePath: 'images/infil-patrol.jpg', minStage: 0,
    choices: [
      { id: 'patrol_a', labelKey: 'infil_ch_patrol_a_label', descKey: 'infil_ch_patrol_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 40, rewardDocs: 0, tag: 'safe' },
      { id: 'patrol_b', labelKey: 'infil_ch_patrol_b_label', descKey: 'infil_ch_patrol_b_desc',
        statType: 'disguise', baseSuccess: 72, difficulty: 12, detectionOnSuccess: 5, detectionOnFail: 22, rewardIp: 260, rewardDocs: 0, tag: 'risky' },
      { id: 'patrol_c', labelKey: 'infil_ch_patrol_c_label', descKey: 'infil_ch_patrol_c_desc',
        statType: 'combat', baseSuccess: 52, difficulty: 24, detectionOnSuccess: 14, detectionOnFail: 40, rewardIp: 820, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'security_check', titleKey: 'infil_ev_security_check_title', categoryKey: 'infil_ev_security_check_cat',
    descKey: 'infil_ev_security_check_desc', imagePath: 'images/infil-security-check.jpg', minStage: 0,
    choices: [
      { id: 'security_check_a', labelKey: 'infil_ch_security_check_a_label', descKey: 'infil_ch_security_check_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 45, rewardDocs: 0, tag: 'safe' },
      { id: 'security_check_b', labelKey: 'infil_ch_security_check_b_label', descKey: 'infil_ch_security_check_b_desc',
        statType: 'disguise', baseSuccess: 70, difficulty: 14, detectionOnSuccess: 6, detectionOnFail: 24, rewardIp: 280, rewardDocs: 0, tag: 'risky' },
      { id: 'security_check_c', labelKey: 'infil_ch_security_check_c_label', descKey: 'infil_ch_security_check_c_desc',
        statType: 'hacking', baseSuccess: 54, difficulty: 22, detectionOnSuccess: 12, detectionOnFail: 36, rewardIp: 760, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'informant', titleKey: 'infil_ev_informant_title', categoryKey: 'infil_ev_informant_cat',
    descKey: 'infil_ev_informant_desc', imagePath: 'images/infil-informant.jpg', minStage: 0,
    choices: [
      { id: 'informant_a', labelKey: 'infil_ch_informant_a_label', descKey: 'infil_ch_informant_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 40, rewardDocs: 0, tag: 'safe' },
      { id: 'informant_b', labelKey: 'infil_ch_informant_b_label', descKey: 'infil_ch_informant_b_desc',
        statType: 'charisma', baseSuccess: 74, difficulty: 12, detectionOnSuccess: 4, detectionOnFail: 20, rewardIp: 300, rewardDocs: 0, tag: 'risky' },
      { id: 'informant_c', labelKey: 'infil_ch_informant_c_label', descKey: 'infil_ch_informant_c_desc',
        statType: 'combat', baseSuccess: 50, difficulty: 26, detectionOnSuccess: 15, detectionOnFail: 42, rewardIp: 900, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'cctv', titleKey: 'infil_ev_cctv_title', categoryKey: 'infil_ev_cctv_cat',
    descKey: 'infil_ev_cctv_desc', imagePath: 'images/infil-cctv.jpg', minStage: 0,
    choices: [
      { id: 'cctv_a', labelKey: 'infil_ch_cctv_a_label', descKey: 'infil_ch_cctv_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 42, rewardDocs: 0, tag: 'safe' },
      { id: 'cctv_b', labelKey: 'infil_ch_cctv_b_label', descKey: 'infil_ch_cctv_b_desc',
        statType: 'hacking', baseSuccess: 72, difficulty: 12, detectionOnSuccess: 5, detectionOnFail: 22, rewardIp: 270, rewardDocs: 0, tag: 'risky' },
      { id: 'cctv_c', labelKey: 'infil_ch_cctv_c_label', descKey: 'infil_ch_cctv_c_desc',
        statType: 'combat', baseSuccess: 52, difficulty: 24, detectionOnSuccess: 13, detectionOnFail: 38, rewardIp: 800, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'fake_id', titleKey: 'infil_ev_fake_id_title', categoryKey: 'infil_ev_fake_id_cat',
    descKey: 'infil_ev_fake_id_desc', imagePath: 'images/infil-fake-id.jpg', minStage: 0,
    choices: [
      { id: 'fake_id_a', labelKey: 'infil_ch_fake_id_a_label', descKey: 'infil_ch_fake_id_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 44, rewardDocs: 0, tag: 'safe' },
      { id: 'fake_id_b', labelKey: 'infil_ch_fake_id_b_label', descKey: 'infil_ch_fake_id_b_desc',
        statType: 'disguise', baseSuccess: 71, difficulty: 13, detectionOnSuccess: 5, detectionOnFail: 23, rewardIp: 285, rewardDocs: 0, tag: 'risky' },
      { id: 'fake_id_c', labelKey: 'infil_ch_fake_id_c_label', descKey: 'infil_ch_fake_id_c_desc',
        statType: 'charisma', baseSuccess: 53, difficulty: 23, detectionOnSuccess: 12, detectionOnFail: 37, rewardIp: 780, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'parking', titleKey: 'infil_ev_parking_title', categoryKey: 'infil_ev_parking_cat',
    descKey: 'infil_ev_parking_desc', imagePath: 'images/infil-parking.jpg', minStage: 0,
    choices: [
      { id: 'parking_a', labelKey: 'infil_ch_parking_a_label', descKey: 'infil_ch_parking_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 40, rewardDocs: 0, tag: 'safe' },
      { id: 'parking_b', labelKey: 'infil_ch_parking_b_label', descKey: 'infil_ch_parking_b_desc',
        statType: 'combat', baseSuccess: 70, difficulty: 14, detectionOnSuccess: 6, detectionOnFail: 24, rewardIp: 275, rewardDocs: 0, tag: 'risky' },
      { id: 'parking_c', labelKey: 'infil_ch_parking_c_label', descKey: 'infil_ch_parking_c_desc',
        statType: 'disguise', baseSuccess: 54, difficulty: 22, detectionOnSuccess: 12, detectionOnFail: 36, rewardIp: 760, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'server_room', titleKey: 'infil_ev_server_room_title', categoryKey: 'infil_ev_server_room_cat',
    descKey: 'infil_ev_server_room_desc', imagePath: 'images/infil-server-room.jpg', minStage: 1,
    choices: [
      { id: 'server_room_a', labelKey: 'infil_ch_server_room_a_label', descKey: 'infil_ch_server_room_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 60, rewardDocs: 0, tag: 'safe' },
      { id: 'server_room_b', labelKey: 'infil_ch_server_room_b_label', descKey: 'infil_ch_server_room_b_desc',
        statType: 'hacking', baseSuccess: 68, difficulty: 18, detectionOnSuccess: 7, detectionOnFail: 26, rewardIp: 360, rewardDocs: 0, tag: 'risky' },
      { id: 'server_room_c', labelKey: 'infil_ch_server_room_c_label', descKey: 'infil_ch_server_room_c_desc',
        statType: 'combat', baseSuccess: 50, difficulty: 28, detectionOnSuccess: 16, detectionOnFail: 44, rewardIp: 1100, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'board_meeting', titleKey: 'infil_ev_board_meeting_title', categoryKey: 'infil_ev_board_meeting_cat',
    descKey: 'infil_ev_board_meeting_desc', imagePath: 'images/infil-board-meeting.jpg', minStage: 2,
    choices: [
      { id: 'board_meeting_a', labelKey: 'infil_ch_board_meeting_a_label', descKey: 'infil_ch_board_meeting_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 70, rewardDocs: 0, tag: 'safe' },
      { id: 'board_meeting_b', labelKey: 'infil_ch_board_meeting_b_label', descKey: 'infil_ch_board_meeting_b_desc',
        statType: 'charisma', baseSuccess: 66, difficulty: 20, detectionOnSuccess: 8, detectionOnFail: 28, rewardIp: 420, rewardDocs: 0, tag: 'risky' },
      { id: 'board_meeting_c', labelKey: 'infil_ch_board_meeting_c_label', descKey: 'infil_ch_board_meeting_c_desc',
        statType: 'combat', baseSuccess: 48, difficulty: 30, detectionOnSuccess: 18, detectionOnFail: 48, rewardIp: 1400, rewardDocs: 2, tag: 'aggressive' },
    ],
  },
  {
    id: 'reporter', titleKey: 'infil_ev_reporter_title', categoryKey: 'infil_ev_reporter_cat',
    descKey: 'infil_ev_reporter_desc', imagePath: 'images/infil-reporter.jpg', minStage: 1,
    choices: [
      { id: 'reporter_a', labelKey: 'infil_ch_reporter_a_label', descKey: 'infil_ch_reporter_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 55, rewardDocs: 0, tag: 'safe' },
      { id: 'reporter_b', labelKey: 'infil_ch_reporter_b_label', descKey: 'infil_ch_reporter_b_desc',
        statType: 'disguise', baseSuccess: 69, difficulty: 16, detectionOnSuccess: 6, detectionOnFail: 25, rewardIp: 340, rewardDocs: 0, tag: 'risky' },
      { id: 'reporter_c', labelKey: 'infil_ch_reporter_c_label', descKey: 'infil_ch_reporter_c_desc',
        statType: 'charisma', baseSuccess: 51, difficulty: 26, detectionOnSuccess: 14, detectionOnFail: 40, rewardIp: 980, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'party', titleKey: 'infil_ev_party_title', categoryKey: 'infil_ev_party_cat',
    descKey: 'infil_ev_party_desc', imagePath: 'images/infil-party.jpg', minStage: 1,
    choices: [
      { id: 'party_a', labelKey: 'infil_ch_party_a_label', descKey: 'infil_ch_party_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 55, rewardDocs: 0, tag: 'safe' },
      { id: 'party_b', labelKey: 'infil_ch_party_b_label', descKey: 'infil_ch_party_b_desc',
        statType: 'charisma', baseSuccess: 69, difficulty: 16, detectionOnSuccess: 6, detectionOnFail: 24, rewardIp: 345, rewardDocs: 0, tag: 'risky' },
      { id: 'party_c', labelKey: 'infil_ch_party_c_label', descKey: 'infil_ch_party_c_desc',
        statType: 'disguise', baseSuccess: 52, difficulty: 25, detectionOnSuccess: 13, detectionOnFail: 39, rewardIp: 940, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'drone', titleKey: 'infil_ev_drone_title', categoryKey: 'infil_ev_drone_cat',
    descKey: 'infil_ev_drone_desc', imagePath: 'images/infil-drone.jpg', minStage: 1,
    choices: [
      { id: 'drone_a', labelKey: 'infil_ch_drone_a_label', descKey: 'infil_ch_drone_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 55, rewardDocs: 0, tag: 'safe' },
      { id: 'drone_b', labelKey: 'infil_ch_drone_b_label', descKey: 'infil_ch_drone_b_desc',
        statType: 'hacking', baseSuccess: 68, difficulty: 17, detectionOnSuccess: 7, detectionOnFail: 26, rewardIp: 350, rewardDocs: 0, tag: 'risky' },
      { id: 'drone_c', labelKey: 'infil_ch_drone_c_label', descKey: 'infil_ch_drone_c_desc',
        statType: 'combat', baseSuccess: 50, difficulty: 27, detectionOnSuccess: 15, detectionOnFail: 42, rewardIp: 1000, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'guard_shift', titleKey: 'infil_ev_guard_shift_title', categoryKey: 'infil_ev_guard_shift_cat',
    descKey: 'infil_ev_guard_shift_desc', imagePath: 'images/infil-guard-shift.jpg', minStage: 0,
    choices: [
      { id: 'guard_shift_a', labelKey: 'infil_ch_guard_shift_a_label', descKey: 'infil_ch_guard_shift_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 42, rewardDocs: 0, tag: 'safe' },
      { id: 'guard_shift_b', labelKey: 'infil_ch_guard_shift_b_label', descKey: 'infil_ch_guard_shift_b_desc',
        statType: 'disguise', baseSuccess: 72, difficulty: 12, detectionOnSuccess: 5, detectionOnFail: 22, rewardIp: 265, rewardDocs: 0, tag: 'risky' },
      { id: 'guard_shift_c', labelKey: 'infil_ch_guard_shift_c_label', descKey: 'infil_ch_guard_shift_c_desc',
        statType: 'combat', baseSuccess: 53, difficulty: 23, detectionOnSuccess: 13, detectionOnFail: 37, rewardIp: 790, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'vault', titleKey: 'infil_ev_vault_title', categoryKey: 'infil_ev_vault_cat',
    descKey: 'infil_ev_vault_desc', imagePath: 'images/infil-vault.jpg', minStage: 2,
    choices: [
      { id: 'vault_a', labelKey: 'infil_ch_vault_a_label', descKey: 'infil_ch_vault_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 75, rewardDocs: 0, tag: 'safe' },
      { id: 'vault_b', labelKey: 'infil_ch_vault_b_label', descKey: 'infil_ch_vault_b_desc',
        statType: 'hacking', baseSuccess: 65, difficulty: 21, detectionOnSuccess: 8, detectionOnFail: 28, rewardIp: 450, rewardDocs: 0, tag: 'risky' },
      { id: 'vault_c', labelKey: 'infil_ch_vault_c_label', descKey: 'infil_ch_vault_c_desc',
        statType: 'combat', baseSuccess: 47, difficulty: 31, detectionOnSuccess: 18, detectionOnFail: 48, rewardIp: 1500, rewardDocs: 2, tag: 'aggressive' },
    ],
  },
  {
    id: 'vaccine', titleKey: 'infil_ev_vaccine_title', categoryKey: 'infil_ev_vaccine_cat',
    descKey: 'infil_ev_vaccine_desc', imagePath: 'images/infil-vaccine.jpg', minStage: 0,
    choices: [
      { id: 'vaccine_a', labelKey: 'infil_ch_vaccine_a_label', descKey: 'infil_ch_vaccine_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 44, rewardDocs: 0, tag: 'safe' },
      { id: 'vaccine_b', labelKey: 'infil_ch_vaccine_b_label', descKey: 'infil_ch_vaccine_b_desc',
        statType: 'disguise', baseSuccess: 71, difficulty: 13, detectionOnSuccess: 5, detectionOnFail: 23, rewardIp: 280, rewardDocs: 0, tag: 'risky' },
      { id: 'vaccine_c', labelKey: 'infil_ch_vaccine_c_label', descKey: 'infil_ch_vaccine_c_desc',
        statType: 'charisma', baseSuccess: 53, difficulty: 23, detectionOnSuccess: 12, detectionOnFail: 37, rewardIp: 800, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
  {
    id: 'broadcast', titleKey: 'infil_ev_broadcast_title', categoryKey: 'infil_ev_broadcast_cat',
    descKey: 'infil_ev_broadcast_desc', imagePath: 'images/infil-broadcast.jpg', minStage: 2,
    choices: [
      { id: 'broadcast_a', labelKey: 'infil_ch_broadcast_a_label', descKey: 'infil_ch_broadcast_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 72, rewardDocs: 0, tag: 'safe' },
      { id: 'broadcast_b', labelKey: 'infil_ch_broadcast_b_label', descKey: 'infil_ch_broadcast_b_desc',
        statType: 'hacking', baseSuccess: 66, difficulty: 20, detectionOnSuccess: 8, detectionOnFail: 27, rewardIp: 430, rewardDocs: 0, tag: 'risky' },
      { id: 'broadcast_c', labelKey: 'infil_ch_broadcast_c_label', descKey: 'infil_ch_broadcast_c_desc',
        statType: 'charisma', baseSuccess: 48, difficulty: 30, detectionOnSuccess: 17, detectionOnFail: 46, rewardIp: 1350, rewardDocs: 2, tag: 'aggressive' },
    ],
  },
  {
    id: 'border', titleKey: 'infil_ev_border_title', categoryKey: 'infil_ev_border_cat',
    descKey: 'infil_ev_border_desc', imagePath: 'images/infil-border.jpg', minStage: 1,
    choices: [
      { id: 'border_a', labelKey: 'infil_ch_border_a_label', descKey: 'infil_ch_border_a_desc',
        statType: 'none', baseSuccess: 100, difficulty: 0, detectionOnSuccess: 0, detectionOnFail: 0, rewardIp: 55, rewardDocs: 0, tag: 'safe' },
      { id: 'border_b', labelKey: 'infil_ch_border_b_label', descKey: 'infil_ch_border_b_desc',
        statType: 'charisma', baseSuccess: 69, difficulty: 16, detectionOnSuccess: 6, detectionOnFail: 24, rewardIp: 340, rewardDocs: 0, tag: 'risky' },
      { id: 'border_c', labelKey: 'infil_ch_border_c_label', descKey: 'infil_ch_border_c_desc',
        statType: 'disguise', baseSuccess: 62, difficulty: 19, detectionOnSuccess: 8, detectionOnFail: 28, rewardIp: 420, rewardDocs: 0, tag: 'risky' },
      { id: 'border_d', labelKey: 'infil_ch_border_d_label', descKey: 'infil_ch_border_d_desc',
        statType: 'combat', baseSuccess: 49, difficulty: 28, detectionOnSuccess: 16, detectionOnFail: 44, rewardIp: 1050, rewardDocs: 1, tag: 'aggressive' },
    ],
  },
];
